import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8aa504e4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aa504e4')) {
      api.createRecord('8aa504e4', component.options)
    } else {
      api.reload('8aa504e4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8aa504e4", function () {
      api.rerender('8aa504e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/task-specification/index.vue"
export default component.exports